import { render, staticRenderFns } from "./EmployeeWarningBanner.vue?vue&type=template&id=6ca8ee54&scoped=true"
import script from "./EmployeeWarningBanner.vue?vue&type=script&lang=js"
export * from "./EmployeeWarningBanner.vue?vue&type=script&lang=js"
import style0 from "./EmployeeWarningBanner.vue?vue&type=style&index=0&id=6ca8ee54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca8ee54",
  null
  
)

export default component.exports